import { QueryClientProvider } from "@tanstack/react-query";
import type { ReactNode } from "react";

import {
  ActiveClientContext,
  AuthContext,
  AuthOperationsContext,
  type AuthQueryFactoryResult,
  AuthStatusContext,
  QueryClientContext,
} from "~/contexts/auth_query";

export function AuthQueryProvider({
  children,
  authResult,
}: {
  children: ReactNode;
  authResult: AuthQueryFactoryResult;
}) {
  const {
    authStatusValue,
    authOperationsValue,
    activeClientValue,
    queryClientValue,
    authValue,
  } = authResult;

  return (
    <QueryClientContext.Provider value={queryClientValue}>
      <AuthStatusContext.Provider value={authStatusValue}>
        <AuthOperationsContext.Provider value={authOperationsValue}>
          <ActiveClientContext.Provider value={activeClientValue}>
            <AuthContext.Provider value={authValue}>
              <QueryClientProvider client={queryClientValue.queryClient}>
                {children}
              </QueryClientProvider>
            </AuthContext.Provider>
          </ActiveClientContext.Provider>
        </AuthOperationsContext.Provider>
      </AuthStatusContext.Provider>
    </QueryClientContext.Provider>
  );
}
